import { get } from "../common/query";

export const GET_COUPON = data => get("/coupon/list", data);
